import { render, staticRenderFns } from "./PlanBlock.vue?vue&type=template&id=328a32cb&scoped=true"
import script from "./PlanBlock.vue?vue&type=script&lang=js"
export * from "./PlanBlock.vue?vue&type=script&lang=js"
import style0 from "./PlanBlock.vue?vue&type=style&index=0&id=328a32cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a32cb",
  null
  
)

export default component.exports